export default __webpack_public_path__ + "static/media/temporarybarrier.dfa1a92b.png";